<div class="activate-container">
  <div class="activate-card">

    <!-- Logo -->
    <div class="logo-section">
      <h1 class="brand">BeFret</h1>
      <p class="brand-subtitle">Plateforme Logistique</p>
    </div>

    <!-- Success state -->
    <div *ngIf="activated" class="success-state">
      <div class="success-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <h2>Compte activ&eacute; !</h2>
      <p>Votre compte <strong>{{ activatedEmail }}</strong> a &eacute;t&eacute; activ&eacute; avec succ&egrave;s.</p>
      <p>Vous pouvez maintenant vous connecter avec votre adresse email et le mot de passe que vous venez de d&eacute;finir.</p>
      <button class="btn btn-primary btn-full" (click)="goToLogin()">
        <i class="fas fa-sign-in-alt"></i> Se connecter
      </button>
    </div>

    <!-- Error state (no token) -->
    <div *ngIf="!token && !activated" class="error-state">
      <div class="error-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h2>Lien invalide</h2>
      <p>{{ error }}</p>
      <button class="btn btn-primary btn-full" (click)="goToLogin()">
        <i class="fas fa-arrow-left"></i> Retour &agrave; la connexion
      </button>
    </div>

    <!-- Form state -->
    <div *ngIf="token && !activated">
      <h2>Activez votre compte</h2>
      <p class="subtitle">D&eacute;finissez votre mot de passe pour activer votre compte BeFret.</p>

      <!-- Error alert -->
      <div *ngIf="error" class="alert alert-error">
        <i class="fas fa-exclamation-circle"></i> {{ error }}
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <!-- Password -->
        <div class="form-group">
          <label class="form-label">Mot de passe</label>
          <input type="password" formControlName="password" class="form-control"
                 placeholder="Votre mot de passe">

          <!-- Password strength -->
          <div *ngIf="form.get('password')?.value" class="password-strength">
            <div class="strength-bar">
              <div class="strength-fill"
                   [style.width]="(passwordStrength / 5 * 100) + '%'"
                   [class.weak]="passwordStrength <= 2"
                   [class.medium]="passwordStrength === 3"
                   [class.strong]="passwordStrength >= 4"></div>
            </div>
            <span class="strength-label"
                  [class.weak]="passwordStrength <= 2"
                  [class.medium]="passwordStrength === 3"
                  [class.strong]="passwordStrength >= 4">
              {{ passwordStrength <= 2 ? 'Faible' : passwordStrength === 3 ? 'Moyen' : 'Fort' }}
            </span>
          </div>

          <!-- Password requirements -->
          <ul *ngIf="passwordErrors.length > 0" class="password-requirements">
            <li *ngFor="let err of passwordErrors" class="requirement-missing">
              <i class="fas fa-times"></i> {{ err }}
            </li>
          </ul>
        </div>

        <!-- Confirm password -->
        <div class="form-group">
          <label class="form-label">Confirmer le mot de passe</label>
          <input type="password" formControlName="confirmPassword" class="form-control"
                 placeholder="Confirmer votre mot de passe">
          <div *ngIf="form.hasError('passwordMismatch') && form.get('confirmPassword')?.dirty"
               class="field-error">
            <i class="fas fa-exclamation-triangle"></i> Les mots de passe ne correspondent pas
          </div>
        </div>

        <!-- Submit -->
        <button type="submit" class="btn btn-primary btn-full"
                [disabled]="loading || form.invalid || passwordErrors.length > 0">
          <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
          <i class="fas fa-check" *ngIf="!loading"></i>
          {{ loading ? 'Activation en cours...' : 'Activer mon compte' }}
        </button>

      </form>
    </div>

  </div>
</div>
